// extracted by mini-css-extract-plugin
export default {"inputWrapper":"new-exercises-chart_inputWrapper__9QKyQ","label":"new-exercises-chart_label__dS2j4","textToolTip":"new-exercises-chart_textToolTip__3SLDb"};